jQuery(function () {
  /*Adding Tab index*/
  $("a").attr("tabindex", "0");
  $(".has-sub-nav").attr("tabindex", "0");
  $(".has-sub-nav").children(".desktop-nav").attr("tabindex", "-1");
  $(".has-sub-nav").children(".site-nav__link").attr("tabindex", "-1");
  $(".ui-autocomplete-input").attr("tabindex", "0");
  $(".accordion-toggle-slide").attr("tabindex", "0");
  $(".accordion-toggle").attr("tabindex", "0");

  $("#PageContainer").attr("tabindex", "0");
  
  

  setTimeout(function () {
    $("#boost-pfs-search-box-mobile").attr("tabindex", "0");
    $("#boost-pfs-search-box-mobile").focus(function() {
      $(".js__cart-expand").click();
    
    });


  }, 1000);
  

  $(".js__cart-expand").focus(function() {
   
    $(".js__cart-expand").click();
   
  });

 

  
  

  $("#hamburger_mobile").attr("tabindex", "0");


  $("#hamburger_mobile").focus(function(e) {
    e.preventDefault();
 
  });

  
  $(".js__cart-item-remove").attr("tabindex", "0");
  $(".announcement-slider").attr("tabindex", "0");
  
  $("a.site-nav__link").focus(function() {
    $(".has-sub-nav").removeClass("focus-active");
    $(".has-sub-nav").removeClass("active");
     $(".accordion-toggle").removeClass("active");
     
      $(".accordion-content").removeClass("active");
     
   
  });
  $(".accordion-toggle-slide").focus(function() {
   console.log("accordion");
        $(this).click();
  })
  $(".accordion-toggle").focus(function() {
    console.log("accordion");
         $(this).click();
   })
   $(".footer-social-links a").focus(function() {
    $(".accordion-toggle").removeClass("active");
    $(".accordion-content").removeClass("active");
   })
   
  $(".mobile-bottom-menu").children("li").children("a").focus(function() {
    if (!$(this).hasClass("accordion-toggle-slide")) {
      $(".accordion-toggle-slide").removeClass("active");
      $(".accordion-content-slide").slideUp(200);
    }
  })
 
  $(".has-sub-nav").focus(function() {
  
    $(".has-sub-nav").removeClass("focus-active");
    $(this).addClass("focus-active");
    $(this).children(".accordion-toggle").click();
  });



  $(".has-sub-nav").mouseover(function() {
    $(".has-sub-nav").removeClass("focus-active");
  })

  $(".announcement-slider").focus(function() {
    console.log("a");
    $("#CartSidebar").removeClass("active");
    $(".js__cart-expand").removeClass("active");
    $("#cart_overlay").removeClass("active");
  });
})
